(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8879],{

/***/ 93039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _vesselCode_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider = __webpack_require__(6339);
// EXTERNAL MODULE: ./main/javascripts/store.ts + 1 modules
var store = __webpack_require__(79169);
// EXTERNAL MODULE: ./main/javascripts/containers/organisms/Header/HeaderContainer.ts
var HeaderContainer = __webpack_require__(12664);
// EXTERNAL MODULE: ./main/javascripts/styles/globalStyle.ts
var globalStyle = __webpack_require__(15305);
// EXTERNAL MODULE: ./i18n.ts + 313 modules
var i18n = __webpack_require__(44349);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/components/head/MainHead.tsx + 2 modules
var MainHead = __webpack_require__(65025);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useConstructor.ts
var useConstructor = __webpack_require__(83795);
// EXTERNAL MODULE: ./main/javascripts/hooks/common/useUserAccount.tsx
var useUserAccount = __webpack_require__(30522);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Block/MainBlock/index.ts
var MainBlock = __webpack_require__(59941);
// EXTERNAL MODULE: ./main/javascripts/components/footer/Footer.tsx
var Footer = __webpack_require__(77747);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/lpCruiseSlice.ts
var lpCruiseSlice = __webpack_require__(30125);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./main/javascripts/utils/ScrollUtil.ts
var ScrollUtil = __webpack_require__(75215);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/utils/UrlUtil.tsx
var UrlUtil = __webpack_require__(28048);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./main/javascripts/components/block/MainBlock.tsx
var block_MainBlock = __webpack_require__(26079);
// EXTERNAL MODULE: ./main/javascripts/components/block/BasicBlock.tsx
var BasicBlock = __webpack_require__(12160);
// EXTERNAL MODULE: ./main/javascripts/components/breadcrumb/Breadcrumb.tsx
var Breadcrumb = __webpack_require__(39181);
// EXTERNAL MODULE: ./main/javascripts/components/pager/Pager.tsx + 3 modules
var Pager = __webpack_require__(55219);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/cruiseSlice.ts
var cruiseSlice = __webpack_require__(78305);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/maxWidthStyle.ts
var maxWidthStyle = __webpack_require__(79105);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseList.tsx
var LpCruiseList = __webpack_require__(25345);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/components/CruiseCardSkeleton.tsx
var CruiseCardSkeleton = __webpack_require__(27735);
// EXTERNAL MODULE: ./main/javascripts/components/lp/RegionList.tsx
var RegionList = __webpack_require__(2932);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseCabinCard.tsx + 1 modules
var CruiseCabinCard = __webpack_require__(12043);
// EXTERNAL MODULE: ./main/javascripts/constants/VesselCabinCategories.ts
var VesselCabinCategories = __webpack_require__(42132);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseCabinList.tsx






var LpCruiseCabinList = function LpCruiseCabinList(props) {
  var vesselCabins = props.vesselCabins;
  var cabinRates = vesselCabins.map(function (cabin) {
    return {
      cruiseUniqueId: "",
      cabinCode: cabin.cabinCode,
      cabinCategory: cabin.cabinCategory,
      priceCents: 0,
      // ratesが存在しない場合は全て0に設定している
      vesselCabin: cabin
    };
  });
  var cabinRatesData = Object.keys(VesselCabinCategories/* VesselCabinCategories */.r).map(function (key) {
    var category = VesselCabinCategories/* VesselCabinCategories */.r[key];
    return cabinRates.filter(function (cabinRate) {
      return cabinRate.cabinCategory === category;
    });
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: cabinListStyle,
    children: cabinRatesData.map(function (cabinRates, index) {
      if (!cabinRates || cabinRates.length === 0) {
        return null;
      }

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseCabinCard/* CruiseCabinCard */.x, {
        cabinRates: cabinRates,
        param: {}
      }, index);
    })
  });
};
var cabinListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:grid;grid-template-columns:1fr;gap:", spaceStyle/* space.atom2x */.D.atom2x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseVesselAttractionList.tsx
var CruiseVesselAttractionList = __webpack_require__(32129);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseVesselAttractionFilterButton.tsx
var CruiseVesselAttractionFilterButton = __webpack_require__(69713);
// EXTERNAL MODULE: ./main/javascripts/constants/VesselAttractionCategories.ts
var VesselAttractionCategories = __webpack_require__(19781);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseVesselAttractions.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var LpCruiseVesselAttractions = function LpCruiseVesselAttractions(props) {
  var vessel = props.vessel;
  var uniqueCategories = Array.from(new Set(vessel.vesselAttractions.map(function (attraction) {
    return attraction.category;
  }))).sort(function (a, b) {
    var indexA = VesselAttractionCategories/* vesselAttractionPreferredOrder.indexOf */.U.indexOf(a);
    var indexB = VesselAttractionCategories/* vesselAttractionPreferredOrder.indexOf */.U.indexOf(b); // 存在しないカテゴリーは末尾に配置

    var orderA = indexA === -1 ? VesselAttractionCategories/* vesselAttractionPreferredOrder.length */.U.length : indexA;
    var orderB = indexB === -1 ? VesselAttractionCategories/* vesselAttractionPreferredOrder.length */.U.length : indexB;
    return orderA - orderB;
  });
  var firstCategory = (uniqueCategories === null || uniqueCategories === void 0 ? void 0 : uniqueCategories[0]) || "";

  var _useState = (0,react.useState)(firstCategory),
      currentCategory = _useState[0],
      setCurrentCategory = _useState[1];

  var onFilterClick = function onFilterClick(category) {
    setCurrentCategory(category);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: filterBlockStyle,
      children: uniqueCategories === null || uniqueCategories === void 0 ? void 0 : uniqueCategories.map(function (category) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseVesselAttractionFilterButton/* CruiseVesselAttractionFilterButton */.$, {
          category: category,
          currentCategory: currentCategory,
          onClick: onFilterClick
        }, category);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: attractionListStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseVesselAttractionList/* CruiseVesselAttractionList */.S, {
        attractions: vessel.vesselAttractions,
        category: currentCategory
      })
    })]
  });
};
var blockStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var filterBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;overflow-x:auto;overflow-y:hidden;padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";display:flex;gap:", spaceStyle/* space.atom2x */.D.atom2x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;scrollbar-width:none;scroll-snap-type:x mandatory;&::-webkit-scrollbar{display:none;}" + ( true ? "" : 0),  true ? "" : 0);
var attractionListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/components/icon/Icon.tsx
var Icon = __webpack_require__(65147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./main/javascripts/features/cruise/components/CruiseVesselImageModal.tsx
var CruiseVesselImageModal = __webpack_require__(82648);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseVesselInfo.tsx



function LpCruiseVesselInfo_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var LpCruiseVesselInfo = function LpCruiseVesselInfo(props) {
  var _vesselImages;

  var vessel = props.vessel;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isDisplayed = _React$useState2[0],
      setIsDisplayed = _React$useState2[1];

  var vesselImages = vessel.vesselImages;

  if (vesselImages && vesselImages.length > 1) {
    vesselImages = [].concat((0,toConsumableArray/* default */.Z)(vesselImages.slice(1)), [vesselImages[0]]);
  }

  var onImageClick = function onImageClick() {
    setIsDisplayed(true);
  };

  var onImageModalClose = function onImageModalClose() {
    setIsDisplayed(false);
  };

  var emptyText = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u2014"
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: LpCruiseVesselInfo_blockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: infoBlockStyle,
      children: [((_vesselImages = vesselImages) === null || _vesselImages === void 0 ? void 0 : _vesselImages.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: imageBlockStyle,
        onClick: onImageClick,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          css: imageStyle,
          src: vesselImages[0].imageUrl,
          alt: ""
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: imageCountStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: imageCountTextStyle,
            children: vesselImages.length
          }), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            css: imageCountIconStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* Icon */.J, {
              styleKey: "images"
            })
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: detailStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: nameStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/vessels/".concat(vessel.code),
            children: vessel.name
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: fileStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: vessel.fileUrl,
            target: "_blank",
            rel: "noreferrer",
            children: t("cruise.viewDeckPlan")
          })
        }), vessel.logoImageUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: logoImageBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            css: logoImageStyle,
            src: vessel.logoImageUrl,
            alt: ""
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: brandNameStyle,
          children: vessel.vesselBrand.name
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: dataBlockStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: dataLabelStyle,
              children: t("cruise.yearBuilt")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: vessel.yearBuilt || emptyText
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: dataLabelStyle,
              children: t("cruise.yearRefurbished")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: vessel.yearRefurbished || emptyText
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: dataLabelStyle,
              children: t("cruise.guestCapacity")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: vessel.guestCapacity || emptyText
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: dataLabelStyle,
              children: t("cruise.onboardCrewCapacity")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: vessel.onboardCrewCapacity || emptyText
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: dataLabelStyle,
              children: t("cruise.lengthInFeet")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: vessel.lengthInFeet || emptyText
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: dataLabelStyle,
              children: t("cruise.grossTonnage")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: vessel.grossTonnage || emptyText
            })]
          })]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseVesselImageModal/* CruiseVesselImageModal */.K, {
      vessel: vessel,
      isDisplayed: isDisplayed,
      onClose: onImageModalClose
    })]
  });
};
var LpCruiseVesselInfo_blockStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var infoBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:100%;display:grid;grid-template-columns:100%;gap:", spaceStyle/* space.atom4x */.D.atom4x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var imageBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;aspect-ratio:3/2;border-radius:", borderStyle/* borderRadius.message */.E.message, ";overflow:hidden;cursor:pointer;margin-bottom:", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{aspect-ratio:1/1;}" + ( true ? "" : 0),  true ? "" : 0);
var imageStyle =  true ? {
  name: "4uwt2b",
  styles: "width:100%;height:100%;object-fit:cover"
} : 0;
var detailStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0 0;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding-top:0;}" + ( true ? "" : 0),  true ? "" : 0);
var nameStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline2 */.Nv.headline2, ";font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";padding:0 0 ", spaceStyle/* space.atom2x */.D.atom2x, " 0;text-align:center;a{color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";text-decoration:none;&:hover{text-decoration:underline;text-underline-offset:4px;}}" + ( true ? "" : 0),  true ? "" : 0);
var fileStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom2x */.D.atom2x, " 0;text-align:center;a{color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";text-decoration:underline;text-underline-offset:0.5rem;}" + ( true ? "" : 0),  true ? "" : 0);
var logoImageBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:20rem;aspect-ratio:2/1;margin:0 auto;padding:", spaceStyle/* space.atom3x */.D.atom3x, " 0 ", spaceStyle/* space.atom2x */.D.atom2x, ";display:flex;align-items:center;justify-content:center;" + ( true ? "" : 0),  true ? "" : 0);
var logoImageStyle =  true ? {
  name: "ukfjzf",
  styles: "width:100%;height:100%;object-fit:contain"
} : 0;
var brandNameStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";padding:0 0 ", spaceStyle/* space.atom */.D.atom, " 0;text-align:center;" + ( true ? "" : 0),  true ? "" : 0);
var dataBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:grid;grid-template-columns:1fr 1fr 1fr;gap:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;max-width:24rem;margin:0 auto;position:relative;left:1rem;" + ( true ? "" : 0),  true ? "" : 0);
var dataLabelStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";padding-bottom:", spaceStyle/* space.atom */.D.atom, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageCountStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:absolute;top:", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";right:", spaceStyle/* space.atom1_5x */.D.atom1_5x, ";background:rgba(0, 0, 0, 0.5);padding:0.5rem 0.75rem;color:#fff;display:flex;align-items:center;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageCountTextStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";padding-right:", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";" + ( true ? "" : 0),  true ? "" : 0);
var imageCountIconStyle =  true ? {
  name: "v6tfo0",
  styles: "position:relative;font-size:1.1875rem;display:flex;align-items:center"
} : 0;
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseFaqList.tsx
var LpCruiseFaqList = __webpack_require__(45417);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseIntroduction.tsx
var LpCruiseIntroduction = __webpack_require__(75767);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseYouTubeVideo.tsx
var LpCruiseYouTubeVideo = __webpack_require__(24814);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseSaleList.tsx + 3 modules
var LpCruiseSaleList = __webpack_require__(91382);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseAdvancedSearchForm.tsx
var LpCruiseAdvancedSearchForm = __webpack_require__(19454);
// EXTERNAL MODULE: ./main/javascripts/features/lp/cruise/components/LpCruiseSorterForm.tsx
var LpCruiseSorterForm = __webpack_require__(89072);
// EXTERNAL MODULE: ./main/javascripts/components/lp/cruise/FixedConsultationButtonBlock.tsx
var FixedConsultationButtonBlock = __webpack_require__(60206);
;// CONCATENATED MODULE: ./main/javascripts/features/lp/cruise/components/LpVesselShowMain.tsx



function LpVesselShowMain_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


































var LpVesselShowMain = function LpVesselShowMain() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var appDispatch = (0,store/* useAppDispatch */.TL)();
  var blockRef = (0,react.useRef)();
  var router = (0,next_router.useRouter)();
  var vessel = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* vesselSelector */.KN);
  var cruises = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* cruisesSelector */.AV);
  var sales = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* salesSelector */.gk);
  var regions = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* regionsSelector */.uT);
  var page = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* pageSelector */._p);
  var totalNum = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* totalNumSelector */.rN);
  var numPerPage = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* numPerPageSelector */.KD);
  var isLoading = (0,store/* useAppSelector */.CG)(lpCruiseSlice/* loadingSelector */.E2);
  var vesselBrand = vessel.vesselBrand;
  var routerPage = router.query.page; // ブラウザの戻る/進むボタンにも対応できるように
  // URLクエリのpageが変化したらfetchする
  // 2ページ目以降に直接アクセスした場合の初回データもここで取得する

  (0,react.useEffect)(function () {
    var newPage = routerPage ? Number(routerPage) : 1;

    if (newPage !== page) {
      appDispatch((0,cruiseSlice/* fetchCruises */.Zr)({
        params: {
          vessel_code: [vessel.code],
          page: newPage,
          sort_by: [{
            sort_name: "departure_date",
            order: "asc"
          }]
        }
      }));
    }
  }, [routerPage]);

  var pagerHandler = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(page) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // ページネーションをクリックしたときはURLだけ変更し
              // useEffectでfetchさせる
              (0,UrlUtil/* pushUrl */.ir)({
                page: page
              }, router);
              (0,ScrollUtil/* scrollTo */.X5)(0, 1000);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function pagerHandler(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var breadcrumbItems = [{
    label: t("cruise.cruise"),
    url: "/cruise"
  }];
  breadcrumbItems.push({
    label: vesselBrand.name,
    url: vesselBrand.lpUrl
  });
  breadcrumbItems.push({
    label: vessel.name
  });

  var renderBreadcrumb = function renderBreadcrumb() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: breadcrumbBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: breadcrumbInnerStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: breadcrumbStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* Breadcrumb */.a, {
            items: breadcrumbItems
          })
        })
      })
    });
  };

  var renderCruiseSaleList = function renderCruiseSaleList() {
    if (page > 1) {
      return null;
    }

    if (!sales || sales.length === 0) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: cruiseListBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: saleTitleStyle,
            children: t("lp.cruiseSaleListTitle")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: cruiseSaleListStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseSaleList/* LpCruiseSaleList */.W, {
              saleCruises: sales
            })
          })]
        })
      })
    });
  };

  var renderCruiseList = function renderCruiseList() {
    var cruiseCount = 10;
    var hasCruise = (cruises === null || cruises === void 0 ? void 0 : cruises.length) > 0;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: cruiseListBlockStyle,
      ref: blockRef,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: titleStyle,
            children: t("lp.vesselCruiseListTitle", {
              name: vessel.name
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: cruiseListToolbarStyle,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseAdvancedSearchForm/* LpCruiseAdvancedSearchForm */.m, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseSorterForm/* LpCruiseSorterForm */.D, {})]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: !isLoading ? hasCruise && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseList/* LpCruiseList */.w, {
              cruises: cruises
            }) : Array.from(Array(cruiseCount)).map(function (_, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseCardSkeleton/* CruiseCardSkeleton */.Z, {}, index);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: pagerBlockStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pager/* Pager */.u, {
              totalNum: totalNum,
              page: page,
              numPerPage: numPerPage,
              handler: pagerHandler
            })
          })]
        })
      })
    });
  };

  var renderYouTubeVideo = function renderYouTubeVideo() {
    var _vessel$vesselLpConte;

    var youtubeLink = (_vessel$vesselLpConte = vessel.vesselLpContent) === null || _vessel$vesselLpConte === void 0 ? void 0 : _vessel$vesselLpConte.youtubeLink;

    if (!youtubeLink) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: youTubeVideoBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseYouTubeVideo/* LpCruiseYouTubeVideo */.r, {
            youtubeLink: youtubeLink
          })
        })
      })
    });
  };

  var renderCabinList = function renderCabinList() {
    var vesselCabins = vessel.vesselCabins || [];

    if (!vesselCabins || vesselCabins.length === 0) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: cruiseListBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: titleStyle,
            children: t("lp.vesselCabinListTitle", {
              name: vessel.name
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: LpVesselShowMain_cabinListStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseCabinList, {
              vesselCabins: vesselCabins
            })
          })]
        })
      })
    });
  };

  var renderAttractionList = function renderAttractionList() {
    var attractions = vessel.vesselAttractions || [];

    if (!attractions || attractions.length === 0) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: attractionBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: titleStyle,
            children: t("lp.vesselAttractionListTitle", {
              name: vessel.name
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: LpVesselShowMain_attractionListStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseVesselAttractions, {
              vessel: vessel
            })
          })]
        })
      })
    });
  };

  var renderInfo = function renderInfo() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
      styleKey: "blockWide",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
          css: titleStyle,
          children: t("lp.vesselInfoTitle", {
            name: vessel.name
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: LpVesselShowMain_attractionListStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseVesselInfo, {
            vessel: vessel
          })
        })]
      })
    });
  };

  var renderIntroduction = function renderIntroduction() {
    var _vessel$vesselLpConte2;

    var introduction = (_vessel$vesselLpConte2 = vessel.vesselLpContent) === null || _vessel$vesselLpConte2 === void 0 ? void 0 : _vessel$vesselLpConte2.introduction;

    if (!introduction) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: introductionBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: titleStyle,
            children: t("lp.vesselIntroductionTitle", {
              name: vessel.name
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: introductionStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseIntroduction/* LpCruiseIntroduction */.j, {
              introduction: introduction
            })
          })]
        })
      })
    });
  };

  var renderFaqList = function renderFaqList() {
    var _vessel$vesselLpConte3;

    var faqs = (_vessel$vesselLpConte3 = vessel.vesselLpContent) === null || _vessel$vesselLpConte3 === void 0 ? void 0 : _vessel$vesselLpConte3.faqs;

    if (!faqs || faqs.length === 0) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: faqBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: titleStyle,
            children: t("lp.vesselFaqTitle", {
              name: vessel.name
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: faqListStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpCruiseFaqList/* LpCruiseFaqList */.U, {
              faqs: faqs
            })
          })]
        })
      })
    });
  };

  var renderRegions = function renderRegions() {
    if (!regions || regions.length === 0) {
      return null;
    }

    var listItems = regions.map(function (region) {
      return {
        text: region.name,
        url: "/cruise_dst/".concat(region.id)
      };
    });
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: textListBlockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BasicBlock/* BasicBlock */.M, {
        styleKey: "blockWide",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
            css: titleStyle,
            children: t("lp.searchByVesselRegions", {
              name: vessel.name
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: regionListStyle,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionList/* RegionList */.Y, {
              listItems: listItems
            })
          })]
        })
      })
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(block_MainBlock/* MainBlock */.R, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: LpVesselShowMain_blockStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("article", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: headerBlockStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BasicBlock/* BasicBlock */.M, {
            styleKey: "blockWide",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              css: headerSubtitleStyle,
              children: t("cruise.vessel")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
              css: headerTitleStyle,
              children: vessel.name
            })]
          })
        }), renderCruiseSaleList(), renderCruiseList(), renderYouTubeVideo(), renderCabinList(), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          css: seconddaryAreaStyle,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: LpVesselShowMain_infoBlockStyle,
            children: [renderAttractionList(), renderInfo()]
          }), renderIntroduction(), renderFaqList(), renderRegions(), renderBreadcrumb()]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FixedConsultationButtonBlock/* FixedConsultationButtonBlock */.e, {})]
  });
};
var LpVesselShowMain_blockStyle =  true ? {
  name: "8cz73a",
  styles: "padding:0 0 3rem"
} : 0;
var headerBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var headerSubtitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom0_5x */.D.atom0_5x, ";font-size:", typographyStyle/* fontSize.body */.JB.body, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";line-height:1.4;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";color:", colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor, ";opacity:0.5;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{text-align:center;}" + ( true ? "" : 0),  true ? "" : 0);
var headerTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, ";font-size:1.75rem;font-weight:", typographyStyle/* fontWeight.bold */.Ue.bold, ";line-height:1.4;letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{text-align:center;font-size:2.5rem;letter-spacing:0.025em;}" + ( true ? "" : 0),  true ? "" : 0);
var cruiseListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 0 ", spaceStyle/* space.atom4x */.D.atom4x, ";max-width:100%;box-sizing:border-box;background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var titleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";color:", colorStyle/* accentColor.secondaryColor2 */.z.secondaryColor2, ";padding:", spaceStyle/* space.atom */.D.atom, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";margin:", spaceStyle/* space.atom */.D.atom, " 0;position:relative;padding-bottom:", spaceStyle/* space.atom2x */.D.atom2x, ";&:before{content:\"\";position:absolute;bottom:0;display:block;height:1px;width:calc(100% - ", spaceStyle/* space.atom2x */.D.atom2x, ");background:#ddd;}&:after{content:\"\";position:absolute;bottom:0;display:block;height:1px;width:3rem;background:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.title */.JB.title, ";line-height:", typographyStyle/* lineHeight.title */.Nv.title, ";}" + ( true ? "" : 0),  true ? "" : 0);
var saleTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.headline */.JB.headline, ";line-height:", typographyStyle/* lineHeight.headline1 */.Nv.headline1, ";color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";padding:", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, " 0;font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";letter-spacing:", typographyStyle/* letterSpacing.text */.rX.text, ";margin:", spaceStyle/* space.atom */.D.atom, " 0 0;position:relative;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{font-size:", typographyStyle/* fontSize.title */.JB.title, ";line-height:", typographyStyle/* lineHeight.title */.Nv.title, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{text-align:center;}" + ( true ? "" : 0),  true ? "" : 0);
var cruiseSaleListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var cruiseListToolbarStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:flex;gap:", spaceStyle/* space.atom2x */.D.atom2x, ";padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var LpVesselShowMain_cabinListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom */.D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var youTubeVideoBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:0 ", spaceStyle/* space.atom */.D.atom, " ", spaceStyle/* space.atom4x */.D.atom4x, ";background-color:", colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var seconddaryAreaStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom4x */.D.atom4x, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var textListBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-bottom:", spaceStyle/* space.atom4x */.D.atom4x, ";" + ( true ? "" : 0),  true ? "" : 0);
var LpVesselShowMain_infoBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:grid;grid-template-columns:100%;gap:", spaceStyle/* space.atom4x */.D.atom4x, ";max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:0 auto ", spaceStyle/* space.atom2x */.D.atom2x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), "{max-width:", maxWidthStyle/* maxWidth.page2colWide */.k.page2colWide, ";margin:0 auto ", spaceStyle/* space.atom2x */.D.atom2x, ";padding:0 ", spaceStyle/* space.atom */.D.atom, ";grid-template-columns:minmax(0, 1.2fr) minmax(0, 0.8fr);}" + ( true ? "" : 0),  true ? "" : 0);
var attractionBlockStyle =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;
var LpVesselShowMain_attractionListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2_5x */.D.atom2_5x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var introductionBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-bottom:", spaceStyle/* space.atom4x */.D.atom4x, ";" + ( true ? "" : 0),  true ? "" : 0);
var introductionStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom4x */.D.atom4x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var faqBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-bottom:", spaceStyle/* space.atom4x */.D.atom4x, ";" + ( true ? "" : 0),  true ? "" : 0);
var faqListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom4x */.D.atom4x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var regionListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2_5x */.D.atom2_5x, " ", spaceStyle/* space.atom */.D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom4x */.D.atom4x, " 0 ", spaceStyle/* space.atom */.D.atom, ";max-width:100%;box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbInnerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:", maxWidthStyle/* maxWidth.page1colWide */.k.page1colWide, ";margin:0 auto;padding:0 ", spaceStyle/* space.atom2x */.D.atom2x, ";box-sizing:border-box;" + ( true ? "" : 0),  true ? "" : 0);
var breadcrumbStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " 0;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";border-bottom:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";" + ( true ? "" : 0),  true ? "" : 0);
var pagerBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("max-width:30rem;margin:2rem auto ", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./pages/vessels/[vesselCode].tsx



















function VesselShow(props) {
  var vesselCode = props.vesselCode,
      vessel = props.vessel,
      cruises = props.cruises,
      sales = props.sales,
      regions = props.regions,
      breadcrumbs = props.breadcrumbs,
      totalNum = props.totalNum,
      page = props.page,
      numPerPage = props.numPerPage,
      locale = props.locale;
  var origin = Constants/* HOST */.M5;
  var isInitializedRef = (0,react.useRef)(false);

  var initializeData = function initializeData() {
    store/* store.dispatch */.h.dispatch((0,lpCruiseSlice/* initLpVessel */.lp)({
      vessel: vessel,
      cruises: cruises,
      sales: sales,
      regions: regions,
      breadcrumbs: breadcrumbs,
      page: page,
      numPerPage: numPerPage,
      totalNum: totalNum
    }));
  };

  (0,useConstructor/* useConstructor */.g)(function () {
    initializeData();

    if (i18n/* default.language */.Z.language !== locale) {
      void i18n/* default.changeLanguage */.Z.changeLanguage(locale);
    }

    globalStyle/* extended.css */.bU.css(globalStyle/* defaultStyles */.jF[globalStyle/* GLOBALS */.UH]);
    isInitializedRef.current = true;
  });
  (0,react.useEffect)(function () {
    // 初期化後にルートが変更された場合再設定する
    if (isInitializedRef.current) {
      initializeData();
    }
  }, [vesselCode]);
  (0,useUserAccount/* useUserAccount */.q)(store/* store */.h);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(es/* Provider */.zt, {
    store: store/* store */.h,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainHead/* MainHead */.I, {
      origin: origin,
      title: vessel.metatitle,
      description: vessel.metadescription
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(I18nextProvider/* I18nextProvider */.a, {
      i18n: i18n/* default */.Z,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer/* HeaderContainer */.g, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainBlock/* MainBlock */.R, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LpVesselShowMain, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* Footer */.$, {})]
      })
    })]
  });
}

var __N_SSG = true;
/* harmony default export */ var _vesselCode_ = (VesselShow);

/***/ }),

/***/ 59542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vessels/[vesselCode]",
      function () {
        return __webpack_require__(93039);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8053,9481,9113,5057,1906,2912,9923,4170,4602,2802,853,1664,7744,8808,9224,1323,7993,7210,4349,6129,8740,9918,5147,4750,5284,6852,5543,2582,9938,7499,5219,4506,9599,3244,8392,9926,7386,6161,2391,3371,9774,2888,179], function() { return __webpack_exec__(59542); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);